import { CallApi } from "app/_helpers/CallApi/CallApi";

export async function getCapaOwner(filter) {
  let url = "/global-configuration/ehs-module/capa-owners";
  return await CallApi(url, "GET");
}

export async function getCapaOwnerByID(id) {
  let url = "/global-configuration/ehs-module/capa-owners/" + id;
  return await CallApi(url, "GET");
}

export async function createCapaOwner(data) {
  let url = "/global-configuration/ehs-module/capa-owners";
  return await CallApi(url, "POST", data);
}

export async function updateCapaOwner(id, data) {
  let url = "/global-configuration/ehs-module/capa-owners/" + id;
  return await CallApi(url, "PUT", data);
}

export async function deleteCapaOwner(id, data) {
  let url = "/global-configuration/ehs-module/capa-owners/" + id;
  return await CallApi(url, "DELETE", data);
}
